import { Injectable, Type } from '@angular/core';
import {
  ApiResponse,
  BaseApiService,
} from '@kinet-open-network/client/core/api-client';
import { plainToInstance } from 'class-transformer';
import { map } from 'rxjs';
import { CustomerBankAccount } from '../models/customer-bank-account.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerBankAccountsService extends BaseApiService<CustomerBankAccount> {
  override model: Type<CustomerBankAccount> = CustomerBankAccount;

  override get endpoint(): string {
    return '/invoicing/customer-bank-accounts';
  }

  restore(id: string) {
    return this.http
      .post<ApiResponse<CustomerBankAccount>>(
        `${this.endpoint}/${this.encodeId(id)}/restore`,
        null,
        {
          context: this.subjectContext(),
        },
      )
      .pipe(map(({ data }) => plainToInstance(this.model, data)));
  }
}
